export default __webpack_public_path__ + "static/media/bear@3x.e0373e62.png";